import dayjs from "dayjs";

export const getStableTodayIso = () => dayjs().format("YYYY-MM-DD");

export const getStableTomorrowIso = () =>
  dayjs().add(1, "day").format("YYYY-MM-DD");
